import { makeStyles, Theme } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

interface IStylesProps {
  foregroundColor: string;
}

export default makeStyles<Theme, IStylesProps>((theme: MuiTheme) => {
  const { main } = theme.palette.primary;
  return {
    listItem: {
      backgroundColor: "transparent",
      padding: 16,
      paddingLeft: 20,
      paddingRight: 20,
      color: "inherit",
      [theme.breakpoints.down("md")]: {
        padding: 18
      }
    },
    listItemSmall: {
      padding: "11px 10px",
      paddingLeft: 20,
      paddingRight: 20
    },
    listItemIcon: {
      minWidth: 45
    },
    listItemText: {
      color: "inherit"
    },
    listItemSelected: {
      color: ({ foregroundColor }) =>
        foregroundColor ? `#${foregroundColor}` : main
    }
  };
});
